export default __webpack_public_path__ + "static/media/ci.80914fb0.png";